// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file <INSERT_FILE_DESCRIPTION_HERE>
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
class CarouselContainer extends HTMLElement {
    cards = /** @type {HTMLElement[]} */ ([])

    constructor() {
        super()
    }

    connectedCallback() {
        // 
        for (const card of this.querySelectorAll("div.card-container >*")) {
            const scrollToNearestEdge = !card.previousElementSibling ||
                !card.nextElementSibling
            card.addEventListener("click", () => {
                card.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: scrollToNearestEdge ? "nearest" : "center"
                })
            })
            this.cards.push(/** @type {HTMLElement} */ (card))
        }

        // 
        this.querySelector("div.carousel-nav.left")
            ?.addEventListener("click", () => {
                this.scrollCardIntoViewByIndex(this.#previousCardIndex)
            })

        // 
        this.querySelector("div.carousel-nav.right")
            ?.addEventListener("click", () => {
                this.scrollCardIntoViewByIndex(this.#nextCardIndex)
            })
    }

    /**
     * 
     * @param {number} index 
     */
    scrollCardIntoViewByIndex(index) {
        index = (this.cards.length + index) % this.cards.length
        this.cards[index].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: index === 0 || index === this.cards.length - 1 ? "nearest"
                : "center"
        })
    }

    get #previousCardIndex() {
        // 
        const cardContainer = this.querySelector("div.card-container")
        if (!cardContainer) { return NaN }

        // 
        if (cardContainer.scrollLeft === 0) { return this.cards.length - 1 }

        // 
        const scrollLeft = cardContainer.scrollLeft + this.clientWidth / 2
        const index = this.cards.findLastIndex(card => {
            return card.offsetLeft + card.clientWidth / 2 < scrollLeft
        })

        return index
    }

    get #nextCardIndex() {
        // 
        const cardContainer = this.querySelector("div.card-container")
        if (!cardContainer) { return NaN }

        // 
        const maxScrollLeft = cardContainer.scrollWidth - this.scrollWidth
        if (cardContainer.scrollLeft === maxScrollLeft) { return 0 }

        // 
        const scrollLeft = cardContainer.scrollLeft + this.clientWidth / 2
        const index = this.cards.findIndex(card => {
            return card.offsetLeft + card.clientWidth / 2 > scrollLeft
        })

        return index
    }


    static get customName() {
        return "carousel-container"
    }
}

// @@exports
export { CarouselContainer }
